import { PanoramaImage } from "@nova/protobuf"
import {
    entityValidator,
    idValidators,
    latitudeValidators,
    longitudeValidators,
    UnionToTuple,
} from "../util"

export const createPanoramaImageValidator = entityValidator(PanoramaImage, {
    // prototodo: review this
    id: { validators: idValidators, nonNull: true },
    longitude: { validators: longitudeValidators },
    latitude: { validators: latitudeValidators },
    altitude: { validators: [] },
    // height: { validators: [], nonNull: true },
    pitch: { validators: [] },
    yaw: { validators: [] },
    roll: { validators: [] },
    flightPitch: { validators: [] },
    flightYaw: { validators: [] },
    flightRoll: { validators: [] },
    takenAt: { validators: [], nonNull: true },
})

export const updatePanoramaImageValidator = entityValidator(PanoramaImage, {})
export const getDefaultPanoramaImageCreateArgs = () => ({})
export type CreatePanoramaImageArgs = UnionToTuple<keyof typeof createPanoramaImageValidator>
export type UpdatePanoramaImageArgs = UnionToTuple<keyof typeof updatePanoramaImageValidator>
